export const AGENT_WORKSPACE_ANCHOR_SCHEMA_VERSION =
  "cogo.studio-agent-workspace-anchor.v1" as const;

export type AgentWorkspaceAnchorKind =
  | "studio.workspace"
  | "application.page"
  | "application.block"
  | "report.document"
  | "report.section"
  | "report.paragraph"
  | "report.table"
  | "report.table-row"
  | "report.table-cell"
  | "report.chart"
  | "report.image"
  | "sheet.workbook"
  | "sheet.range"
  | "sheet.chart"
  | "export.artifact";

export type AgentWorkspaceTargetFormat =
  | "preview"
  | "pdf"
  | "docx"
  | "pptx"
  | "hwpx"
  | "xlsx";

export interface AgentWorkspaceAnchorRefs {
  appId?: string;
  pageId?: string;
  blockId?: string;
  propertyKey?: string;
  flowIds?: string[];
  reportNodeId?: string;
  sourceBindingId?: string;
  ontologyClassIds?: string[];
  ruleIds?: string[];
  previewElementId?: string;
  exportArtifactIds?: string[];
}

export interface AgentWorkspaceAnchorBounds {
  x: number;
  y: number;
  width: number;
  height: number;
}

export interface AgentWorkspaceAnchor {
  schemaVersion: typeof AGENT_WORKSPACE_ANCHOR_SCHEMA_VERSION;
  anchorId: string;
  kind: AgentWorkspaceAnchorKind;
  label: string;
  refs: AgentWorkspaceAnchorRefs;
  targetFormats: AgentWorkspaceTargetFormat[];
  bounds?: AgentWorkspaceAnchorBounds;
  evidenceRefs: string[];
}

export const ROOT_STUDIO_WORKSPACE_ANCHOR: AgentWorkspaceAnchor = {
  schemaVersion: AGENT_WORKSPACE_ANCHOR_SCHEMA_VERSION,
  anchorId: "studio.workspace.root",
  kind: "studio.workspace",
  label: "Studio workspace",
  refs: {},
  targetFormats: ["preview"],
  evidenceRefs: [],
};

export function createAgentWorkspaceAnchor(
  anchor: Omit<AgentWorkspaceAnchor, "schemaVersion">,
): AgentWorkspaceAnchor {
  return {
    schemaVersion: AGENT_WORKSPACE_ANCHOR_SCHEMA_VERSION,
    ...anchor,
  };
}
